/** Must match the lock name in `user-portal-react-core` so the host and mounted React apps never refresh at the same time. */
const refreshTokenLockName = 'k1-refresh-token';

/** Runs `task` while holding the cross-application refresh lock; without Web Locks support it just runs the task. */
export const withRefreshTokenLock = async <T>(task: () => Promise<T>): Promise<T> =>
  'locks' in navigator ? await navigator.locks.request(refreshTokenLockName, task) : task();
